import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import ApplyBtn from "../Components/ApplyBtn";
import MoreBtn from "../Components/MoreBtn";
import ToggleButton from "../Components/ToggleButton";
import Layout from "../Layout/Layout";
import Pagination from "../Layout/Pagination";
import AlarmApply from "../Modals/AlarmApply";
import DonationApply from "../Modals/DonationApply";
import DonationComplete from "../Modals/DonationComplete";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils";
import { compareDates } from "../Utils/numberUtils";
import { showToast } from "../Utils/variables";

const DonationContent = () => {
  const navigate = useNavigate();
  const [isDonationVisible, setIsDonationVisible] = useState(0);
  const [clickDonationVisible, setClickDonationVisible] = useState(false);

  const [page, setPage] = useState(1);
  const [total_donation, setTotal_donation] = useState(0);
  const [donation_list, setDonation_list] = useState([]);

  const [selectedId, setSelectedId] = useState(null);
  const [selectedStartTime, setSelectedStartTime] = useState(new Date());
  const [selectedEndTime, setSelectedEndTime] = useState(new Date());

  const [isComplete, setIsComplete] = useState(null);
  const [clickDelete, setClickDelete] = useState(false);
  const [clickComplete, setClickComplete] = useState(false);
  const [clickApply, setClickApply] = useState(false);
  const [clickEdit, setClickEdit] = useState(false);
  const [clickEditComplete, setClickEditComplete] = useState(false);
  const hasLoadedDonationVisible = useRef(false);
  const lastDonationListRequestKey = useRef(null);

  const getDonationVisible = async () => {
    try {
      const res = await postJson(
        "/dashboard/donation/getDonationVisible",
        {},
        navigate
      );
      if (res.code === 200) {
        setIsDonationVisible(res.data.isDonationVisible);
      }
    } catch (error) {
      console.log("기부발걸음노출여부정보 가져오기 중 에러");
      throw error;
    }
  };

  const handleActive = async () => {
    try {
      const res = await postJson(
        "/dashboard/donation/updateDonationVisible",
        { isDonationVisible: isDonationVisible === 0 ? 1 : 0 },
        navigate
      );

      if (res.code === 200) {
        setIsDonationVisible(res.data.isDonationVisible);
        setClickDonationVisible(false);
      }
    } catch (error) {
      console.log("기부발걸음노출여부 수정 중 에러");
      throw error;
    }
  };

  const getDonationList = async () => {
    try {
      const res = await postJson(
        "/dashboard/donation/getList",
        { page, offset: 10 },
        navigate
      );
      if (res.code === 200) {
        setTotal_donation(res.data.count);
        setDonation_list(res.data.rows);
      }
    } catch (error) {
      console.log("기부발걸음 리스트 가져오기 중 에러");
      throw error;
    }
  };

  const handleApply = async (startTime, endTime) => {
    try {
      const res = await postJson(
        "/dashboard/donation/create",
        { startTime, endTime },
        navigate
      );
      if (res.code === 200) {
        handleClickX();
        setPage(1);
        lastDonationListRequestKey.current = null;
        getDonationList();
        showToast("기부 발걸음이 등록되었습니다.", "success");
        return;
      }

      showToast(res.message || "기부 발걸음을 등록하지 못했습니다.", "error");
    } catch (error) {
      console.log("기부발걸음 등록 중 에러");
      throw error;
    }
  };

  const handleEdit = async (startTime, endTime) => {
    try {
      const body = {
        companyDonationId: selectedId,
        startTime,
        endTime,
      };
      const res = await postJson(
        "/dashboard/donation/update",
        body,
        navigate
      );

      if (res.code === 200) {
        handleClickX();
        lastDonationListRequestKey.current = null;
        getDonationList();
        showToast("기부 발걸음이 수정되었습니다.", "success");
        return;
      }

      showToast(res.message || "기부 발걸음을 수정하지 못했습니다.", "error");
    } catch (error) {
      console.log("기부발걸음 수정 중 에러");
      throw error;
    }
  };

  const handleDelete = async () => {
    try {
      const res = await postJson(
        "/dashboard/donation/delete",
        { companyDonationId: selectedId },
        navigate
      );

      if (res.code === 200) {
        handleClickX();
        const nextPage =
          donation_list.length === 1 && page > 1 ? page - 1 : page;

        if (nextPage !== page) {
          setPage(nextPage);
          showToast("기부 발걸음이 삭제되었습니다.", "success");
          return;
        }

        lastDonationListRequestKey.current = null;
        getDonationList();
        showToast("기부 발걸음이 삭제되었습니다.", "success");
      }
    } catch (error) {
      console.log("기부발걸음 삭제 중 에러");
      throw error;
    }
  };

  const handleComplete = async (money) => {
    try {
      const res = await postJson(
        "/dashboard/donation/createComplete",
        { companyDonationId: selectedId, money },
        navigate
      );
      if (res.code === 200) {
        handleClickX();
        lastDonationListRequestKey.current = null;
        getDonationList();
        showToast("기부 완료 처리가 등록되었습니다.", "success");
      }
    } catch (error) {
      console.log("기부완료 처리 중 에러");
      throw error;
    }
  };

  const handleEditComplete = async (money) => {
    try {
      const res = await postJson(
        "/dashboard/donation/updateComplete",
        { companyDonationCompleteId: selectedId, money },
        navigate
      );

      if (res.code === 200) {
        handleClickX();
        lastDonationListRequestKey.current = null;
        getDonationList();
        showToast("기부 완료 금액이 수정되었습니다.", "success");
      }
    } catch (error) {
      console.log("기부완료처리수정 중 에러");
      throw error;
    }
  };

  const handleClickX = () => {
    setClickDonationVisible(false);
    setClickApply(false);
    setClickDelete(false);
    setClickComplete(false);
    setClickEdit(false);
    setClickEditComplete(false);
  };

  const handleClickDelete = (donationId, completeId) => {
    setSelectedId(donationId);
    setIsComplete(completeId);
    setClickDelete(true);
  };

  const handleClickComplete = (donationId) => {
    setSelectedId(donationId);
    setClickComplete(true);
  };

  const handleClickEdit = (donationId, startTime, endTime) => {
    setSelectedId(donationId);
    setSelectedStartTime(startTime);
    setSelectedEndTime(endTime);
    setClickEdit(true);
  };

  const handleClickEditComplete = (completeId) => {
    setSelectedId(completeId);
    setClickEditComplete(true);
  };

  useEffect(() => {
    if (hasLoadedDonationVisible.current) {
      return;
    }

    hasLoadedDonationVisible.current = true;
    getDonationVisible();
  }, []);

  useEffect(() => {
    const requestKey = JSON.stringify({ page });

    if (lastDonationListRequestKey.current === requestKey) {
      return;
    }

    lastDonationListRequestKey.current = requestKey;
    getDonationList();
  }, [page]);

  return (
    <div>
      {clickDonationVisible && (
        <AlarmApply
          title={
            isDonationVisible === 0
              ? "활성화 하시겠습니까?"
              : "비활성화 하시겠습니까?"
          }
          subtitle={
            isDonationVisible === 0
              ? "앱 기업모드 화면의 UI를 활성화할까요?"
              : "비활성화 시 앱 내에서 발걸음 UI가 숨겨지며 진행중이던 기록은 계속 집계됩니다. 진행하시겠습니까?"
          }
          handleApply={handleActive}
          handleClickX={handleClickX}
        />
      )}
      {clickApply && (
        <DonationApply handleClickX={handleClickX} handleApply={handleApply} />
      )}
      {clickEdit && (
        <DonationApply
          handleClickX={handleClickX}
          handleEdit={handleEdit}
          isEditing={true}
          startTime={selectedStartTime}
          endTime={selectedEndTime}
        />
      )}
      {clickDelete && (
        <AlarmApply
          title={
            isComplete
              ? "기부완료된 발걸음을 삭제하시겠습니까?"
              : "발걸음을 삭제하시곘습니까?"
          }
          subtitle={
            isComplete
              ? "데이터가 삭제되어도 직전 기부 발걸음은 앱 화면에 계속 노출됩니다."
              : "기간이 종료되지 않은 상태로 삭제 시 지금까지의 기록이 사라지고 앱 화면에서도 내역이 사라집니다."
          }
          handleClickX={handleClickX}
          handleApply={handleDelete}
        />
      )}
      {clickComplete && (
        <DonationComplete
          handleComplete={(money) => handleComplete(money)}
          handleClickX={handleClickX}
        />
      )}
      {clickEditComplete && (
        <DonationComplete
          type={selectedId}
          handleClickX={handleClickX}
          handleComplete={(money) => handleEditComplete(money)}
        />
      )}
      <DonationBox>
        <p className="title-in-box">기부 발걸음 관리</p>
        <p
          className="bold-text"
          style={{ fontSize: "18px", marginTop: "20px" }}
        >
          우리기업 누적 기부 발걸음이란?
        </p>
        <p style={{ fontSize: "14px", color: "#555555", marginTop: "4px" }}>
          전체 구성원의 만보기 누적 걸음 수를 측정하고 기부하여 구성원의 만보기
          활동을 증진시켜보세요!
        </p>

        <ToggleBox
          clickDonationVisible={() => setClickDonationVisible(true)}
          isDonationVisible={isDonationVisible}
        />

        <div
          className="hrz-wrapper"
          style={{ marginTop: "20px", width: "1500px" }}
        >
          <p style={{ color: "#000000" }}>전체 {total_donation}건</p>
          <div
            style={{ marginLeft: "auto" }}
            onClick={() => setClickApply(true)}
          >
            <ApplyBtn />
          </div>
        </div>

        <div className="listArea" style={{ marginTop: "10px" }}>
          <div
            className="list_titleBar medium-basetext"
            style={{
              gridTemplateColumns: "100px  220px 100px 240px 240px 600px",
            }}
          >
            <p className="center">NO</p>
            <p className="leftalign">진행 기간</p>
            <p className="leftalign">진행상태</p>
            <p className="leftalign">누적 발걸음</p>
            <p className="leftalign">기부금액</p>
            <p className="leftalign">기부일</p>
          </div>

          {donation_list
            .slice(0, 10)
            .map((data) => (
              <DonationData
                key={data.rownum}
                rownum={data.rownum}
                donationId={data.companyDonationId}
                startTime={data.startTime}
                endTime={data.endTime}
                completeId={data.companyDonationCompleteId}
                totalStep={data.totalStep}
                money={data.money}
                regTime={data.regTime}
                onDelete={handleClickDelete}
                onComplete={handleClickComplete}
                onEdit={handleClickEdit}
                onEditComplete={handleClickEditComplete}
              />
            ))}
        </div>

        {/* 페이징 */}
        <Pagination
          totalPages={total_donation === 0 ? 1 : Math.ceil(total_donation / 10)}
          currentPage={page}
          onPageChange={(value) => setPage(value)}
        />
      </DonationBox>
    </div>
  );
};

const DonationData = ({
  rownum,
  donationId,
  startTime,
  endTime,
  totalStep,
  completeId,
  money,
  regTime,
  onDelete,
  onComplete,
  onEdit,
  onEditComplete,
}) => {
  const status =
    compareDates(startTime) === 1
      ? "진행전"
      : (compareDates(startTime) === -1 || compareDates(startTime) === 0) &&
        (compareDates(endTime) === 1 || compareDates(endTime) === 0)
      ? "진행중"
      : compareDates(endTime) === -1
      ? "기간종료"
      : "";
  return (
    <div
      className="list_contentBar"
      style={{
        gridTemplateColumns: "100px 220px 100px 240px 240px 440px 108px 52px",
      }}
    >
      <p className="center">{rownum}</p>
      <p className="leftalign">{startTime + " ~ " + endTime}</p>
      <p className="leftalign">{status}</p>
      <p className="leftalign">{totalStep}걸음</p>
      <p className="leftalign">
        {completeId ? money?.toLocaleString() + "원" : "-"}
      </p>
      <p className="leftalign">{completeId ? regTime : "-"}</p>
      <div className="center">
        {!completeId && (
          <div
            className="blueBtn-base medium-basetext"
            style={{ width: "104px", height: "36px", borderRadius: "8px" }}
            onClick={() => onComplete(donationId)}
          >
            기부 완료 처리
          </div>
        )}
      </div>
      <div className="center">
        <MoreBtn
          option1="수정"
          option2="삭제"
          editingType={completeId ? "complete" : null}
          optionClickEdit={() => onEdit(donationId, new Date(startTime), new Date(endTime))}
          optionClickEditComplete={() => onEditComplete(completeId)}
          optionClickDelete={() => onDelete(donationId, completeId)}
        />
      </div>
    </div>
  );
};

const ToggleBox = ({ clickDonationVisible, isDonationVisible }) => {
  // 대표 발걸음 설정을 위한 변수
  // const displayData = donation_list.find((data) => data.display === true);

  // const [clickInfo, setClickInfo] = useState(false);
  // const iconRef = useRef(null);
  // const infoBoxRef = useRef(null);

  // const handleClickInfo = () => {
  //   setClickInfo(!clickInfo);
  // };

  // const handleClickOutside = (event) => {
  //   if (
  //     iconRef.current &&
  //     !iconRef.current.contains(event.target) &&
  //     infoBoxRef.current &&
  //     !infoBoxRef.current.contains(event.target)
  //   ) {
  //     setClickInfo(false);
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("mousedown", handleClickOutside);

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);
  return (
    <Box>
      <div className="hrz-wrapper" style={{ width: "488px" }}>
        <p className="medium-text">기부 발걸음 UI 앱 노출 여부 설정</p>
        <div style={{ marginLeft: "auto" }}>
          <ToggleButton
            handleClickToggle={clickDonationVisible}
            setValue={isDonationVisible}
          />
        </div>
      </div>

      <div style={{ width: "488px", marginTop: "30px" }}>
        <p style={{ fontSize: "14px", color: "#555555" }}>
          활성화 시 앱 내 기업모드 ‘랭킹(홈){">"}만보기{">"}전체’ 탭에 ‘우리기업
          누적 기부 발걸음’ UI가 노출되며 대표 발걸음을 설정하기 전까지 ‘준비중’
          으로 노출됩니다.
        </p>
      </div>

      {/* 대표 발걸음 설정 시 보이는 부분 */}
      {/* {donation_list.some((data) => data.display === true) && (
        <div
          style={{
            width: "488px",
          }}
        >
          <div
            className="hrz-line"
            style={{
              backgroundColor: "#e4e4e4",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          />

          {clickInfo && (
            <InfoBox ref={infoBoxRef}>
              현재까지 모인 누적 발걸음 : 전체 구성원의 시작일부터 현재까지 쌓인
              누적 만보기 걸음 수
            </InfoBox>
          )}

          <p
            className="medium-basetext"
            style={
              displayData.status === "진행전"
                ? { color: "#888888" }
                : displayData.status === "진행중"
                ? { color: "#1167ed" }
                : { color: "#F25C5C" }
            }
          >
            {displayData.status}
          </p>
          <p
            className="medium-basetext"
            style={{ marginTop: "6px", color: "#888888" }}
          >
            {displayData.period}
          </p>
          <div className="hrz-wrapper" style={{ marginTop: "20px" }}>
            <p className="medium-text" style={{ marginRight: "4px" }}>
              현재까지 모인 누적 발걸음
            </p>
            <IconInfoFill
              width="20px"
              height="20px"
              onClick={handleClickInfo}
              ref={iconRef}
              style={{ cursor: "pointer" }}
            />
          </div>

          <div style={{ marginTop: "4px", width: "488px" }}>
            <p
              className="bold-text"
              style={{ fontSize: "20px", wordBreak: "break-all" }}
            >
              {displayData.stepcount}걸음
            </p>
          </div>
        </div>
      )} */}
    </Box>
  );
};

const DonationBox = styled.div`
  width: auto;
  height: auto;
  border-radius: 20px;
  padding: 30px;
  background-color: #ffffff;
  margin: 30px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  .medium-basetext {
    font-family: "notoSans-medium";
    font-size: 14px;
    > p {
      font-family: "notoSans-medium";
      font-size: 14px;
    }
  }
`;

const Box = styled.div`
  width: 488px;
  height: auto;
  border-radius: 20px;
  padding: 20px;
  background-color: #ffffff;
  margin-top: 20px;
  box-shadow: inset 0 0 0 1px #e4e4e4;
`;

const InfoBox = styled.div`
  position: absolute;
  width: 332px;
  height: 42px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 5;
  word-break: break-all;
  color: #ffffff;
  font-size: 14px;
  margin-left: 170px;
  padding: 11px 16px;
`;

const Donation = () => {
  return <Layout page={<DonationContent />} />;
};

export default Donation;
